<template>
  <div class="common-send-code">
    <flex-line :show-border="true">
      <span>Verification Method</span>
      <div slot="right">
        <mt-radio v-model="verifyType" :options="verifyTypeOptions">
        </mt-radio>
      </div>
    </flex-line>
    <flex-line class="field-line" :show-border="true"><span class="field-name">Verification Code</span>
      <div class="field-line-right" slot="right"><input class="field-input" v-model="verifyCode" />
        <div @click="sendAuthCode" class="common-btn send-btn">{{ sendStateText }}</div>
      </div>
    </flex-line>
    <div class="common-btn ds-button-large mt-10" @click='checkAuthCode'>Next Step</div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { sendAuthCode, checkAuthCode } from '../../../api/memberSetting'
import { Toast } from 'mint-ui'
import flexLine from '../../flexLine'
export default {
  name: 'CommonSendCode',
  components: {
    flexLine,
  },
  data() {
    return {
      verifyType: 'email',
      verifyCode: '',
      canSend: true,
      sendStateText: 'send',
      verifyTypeOptions: []
    }
  },
  beforeDestroy: function () {
    clearInterval(this.time_interval)
  },
  created: function () {
    if (this.user.member_mobilebind && this.user.member_mobile) {
      this.verifyTypeOptions.push({
        label: 'mobile',
        value: 'mobile'
      })
      this.verifyType = 'mobile'
    }
    if (this.user.member_emailbind && this.user.member_email) {
      this.verifyTypeOptions.push({
        label: 'email',
        value: 'email'
      })
    }
  },
  computed: {
    ...mapState({
      user: state => state.member.info
    })
  },
  methods: {
    sendAuthCode() {
      if (!this.canSend) {
        return
      }
      sendAuthCode(this.verifyType).then(res => {
        this.canSend = false
        let second = 60
        Toast(res.message)
        let _this = this
        this.time_interval = setInterval(function () {
          if (second <= 0) {
            _this.canSend = true
            _this.sendStateText = 'send'
            clearInterval(_this.time_interval)
          } else {
            _this.sendStateText = second + 's'
          }

          second--
        }, 1000)
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    checkAuthCode() {
      checkAuthCode(this.verifyCode).then(res => {
        this.$emit('checkSuccess')
      }).catch(function (error) {
        Toast(error.message)
      })
    }

  }
}
</script>
<style  lang="scss" scoped>
.common-send-code {
  position: relative;
  z-index: 100;
  padding: 0 $pageSpace;

  .send-btn {
    border: 1px solid $primaryColor;
    color: $primaryColor;
    min-width: 2rem
  }
}
</style>
<style  lang="scss">
.common-send-code {
  position: relative;
  z-index: 100;

  .mint-radiolist {
    display: flex;

    .mint-cell {
      flex: 1;

      .mint-radio-input:checked+.mint-radio-core {
        background-color: $primaryColor !important;
        border-color: $primaryColor !important;
      }

      &:after {
        display: none
      }
    }
  }
}
</style>
